import { create } from 'zustand'
import { type Studio } from '@/types/studios'
import type { ZustandStoreCreator } from '@/types/types'

interface SelectedStudioStoreActions {
  setSelectedStudio: (studio: Studio | undefined) => void
  resetSelectedStudio: () => void
  setError: (error: string | undefined) => void
  setNoStudios: (noStudios: boolean) => void
  resetStore: () => void
}

interface SelectedStudioStoreValues {
  selectedStudio: Studio | undefined
  error: string | undefined
  noStudios: boolean
}

type SelectedStudioStore = ZustandStoreCreator<
  SelectedStudioStoreValues,
  SelectedStudioStoreActions
>

export const useSelectedStudioStore = create<SelectedStudioStore>((set) => ({
  selectedStudio: undefined,
  error: undefined,
  noStudios: false,
  actions: {
    setSelectedStudio(studio: Studio | undefined) {
      set({ selectedStudio: studio })
    },
    setError(error: string | undefined) {
      set({ error })
    },
    setNoStudios(noStudios: boolean) {
      set({ noStudios })
    },
    resetSelectedStudio() {
      set({ selectedStudio: undefined })
    },
    resetStore() {
      set({ selectedStudio: undefined, error: undefined, noStudios: false })
    },
  },
}))

export const useSelectedStudioStoreActions = () =>
  useSelectedStudioStore((state) => state.actions)
